<template>
  <div class="detail">
    <van-nav-bar  class="" title="van-nav-bar" left-text="返回" left-arrow @click-left="onClickLeft">
       <template #title>{{ued}}</template>
    </van-nav-bar>
    <div class="content">
      <h5>{{title}}</h5>
      <div class="cont" v-html="contents"></div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { NavBar } from 'vant';
Vue.use(NavBar);
import axios from "axios";
export default {
  data() {
    return {
      ued:'',
      title:'',
      contents:'',
      id:''
    };
  },
  created() {
    this.id=this.$route.params.id
  },
  mounted() {
    this.request()
  },
  methods: {
    onClickLeft() {
      this.$router.push('./Science')
    },
    request(){
      axios.get("/wxapi/InformationRelease/queryById?id="+this.id+"").then(res => {
        this.contents=res.data.data.content
        this.title=res.data.data.title
        this.ued=res.data.data.issued
      })
    }
  }
};
</script>
<style lang="less">
  .cont{
    img{
      width:100%!important;
      height:400px;
    }
  }
  .van-nav-bar{
    background-color: #f9f9f9;
    border-bottom: 1px solid #e4e4e4;
  }  
</style>
<style lang="less" scoped>
.van-nav-bar__title{
  font-size: 35px;
  font-weight: 700;
}
.detail{
  height:100%;
  display: flex;
  flex-direction: column;
  .van-nav-bar{
    flex: 1;
  }
  .content{
    flex: 13;
    overflow: auto;
    h5 {
      margin:20px 0 20px 0;
      text-align: center;
      font-size: 35px;
    }
    .cont{
      width:100%;
      padding:0 20px 5px 20px;
      font-size: 32px!important;
      
    }
    .cont p{
        line-height: 30px!important;
        border: 1px solid red;
      }
  }
}
</style>